import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { TenantContextService } from '../tenant-context/tenant-context.service';

/**
 * Service to manipulate the browser tab title
 */
@Injectable({ providedIn: 'root' })
export class TabTitleService {
    public readonly appName = 'Ignite';
    private currentTenantCode = '';
    private readonly ROUTE_DATA_TITLE_KEY = 'title';
    private titleFromRoute: string | null = '';

    public constructor(
        private title: Title,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private tenantContext: TenantContextService
    ) {}

    public setup(): void {
        this.setTitle();

        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    let child = this.activatedRoute.firstChild;
                    while (child?.firstChild) {
                        child = child.firstChild;
                    }
                    if (child?.snapshot.data[this.ROUTE_DATA_TITLE_KEY]) {
                        return <string>child.snapshot.data[this.ROUTE_DATA_TITLE_KEY];
                    }
                    return null;
                })
            )
            .subscribe((titleFromRoute: string | null) => {
                this.titleFromRoute = titleFromRoute;
                this.setTitle(titleFromRoute);
            });

        this.tenantContext.tenantSelected$.subscribe(() => {
            const tenantCode = this.getCurrentTenantCode();
            if (this.currentTenantCode !== tenantCode) {
                this.setTitle(this.titleFromRoute);
            }
        });
    }

    /** Update browser document's title */
    public setTitle(newTitle?: string | null): void {
        const tenantCode = this.getCurrentTenantCode();
        this.currentTenantCode = tenantCode;
        const title = [tenantCode, newTitle, this.appName].filter(c => c).join(' - ');
        this.title.setTitle(title);
    }

    /** Get browser document's title */
    public getTitle(): string {
        return this.title.getTitle();
    }

    private getCurrentTenantCode(): string {
        return this.tenantContext.showTenantSwitcher ? this.tenantContext.currentTenant?.tenantId || '' : '';
    }
}
